export const categoryList = [
	'Læringsspil',
	'Design af spil',
	'Gamification',
	'Underholdningsspil',
];
